module.exports = __webpack_public_path__ + "static/phone-carrier-intro-circle-2-cb591df8bf2b5b102268b05797c69cca.png";